// extracted by mini-css-extract-plugin
export var root = "CartItem-module--root--deb23";
export var imageContainer = "CartItem-module--imageContainer--1f3cd";
export var itemContainer = "CartItem-module--itemContainer--d4104";
export var adjustItemContainer = "CartItem-module--adjustItemContainer--6312e";
export var priceContainer = "CartItem-module--priceContainer--1c1e9";
export var name = "CartItem-module--name--457aa";
export var metaContainer = "CartItem-module--metaContainer--dc54f";
export var editContainer = "CartItem-module--editContainer--a11df";
export var removeContainer = "CartItem-module--removeContainer--4b27a";